import {
    FORMEDIT_SUBMIT_FORMATTR_BEGIN,
    FORMEDIT_SUBMIT_FORMATTR_SUCCESS,
    FORMEDIT_SUBMIT_FORMATTR_FAILURE,
    FORMEDIT_SUBMIT_FORMATTR_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFormAttr(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FORMEDIT_SUBMIT_FORMATTR_BEGIN,
      });
  
      let apiurl = '/api/b/formAttr/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/formAttr/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: FORMEDIT_SUBMIT_FORMATTR_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: FORMEDIT_SUBMIT_FORMATTR_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFormAttrError() {
    return {
      type: FORMEDIT_SUBMIT_FORMATTR_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_SUBMIT_FORMATTR_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFormAttrPending: true,
          submitFormAttrError: null,
        };
  
      case FORMEDIT_SUBMIT_FORMATTR_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFormAttrPending: false,
          submitFormAttrError: null,
        };
  
      case FORMEDIT_SUBMIT_FORMATTR_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFormAttrPending: false,
          submitFormAttrError: action.data.error,
        };
  
      case FORMEDIT_SUBMIT_FORMATTR_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFormAttrError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/formedit/redux/submitFormAttr.js